export default __webpack_public_path__ + "static/media/101Nights.77ae5b66.jpg";